//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UsuarioHSBC from "@/api/promotores/usuarios/hsbc.api";

export default {
    data() {
        return {
            contactos: [],
            per_page_options: [10, 20, 30, 40, 50, 100],
            columns: [
                { name: "nombre", label: "Nombre", field: "nombre_completo", align: "left", classes: "bg-grey-2 ellipsis", style: "width: 350px", headerClasses: "bg-primary text-white"},
                { name: 'correo', field: 'email', label: 'Email', align: 'left' },
                { name: 'celular', field: 'mobilephone', label: 'Celular', align: 'left' },
                { name: 'hsbc_product', field: 'hsbc_product', label: 'Tipo de crédito', sortable: true, align: 'left' },
                { name: 'status', field: 'status', label: 'Status', sortable: true, align: 'left' },
                { name: 'created_at', field: 'created_at', label: 'Creado', sortable: true, align: 'left' },
            ],
            loading: false,
        }
    },
    mounted() {
        this.loadContactos();
    },
    methods: {
        async loadContactos() {
            try {
                this.loading = true
                this.contactos = await UsuarioHSBC.all(this.$route.params.promotor)
            } finally {
                this.loading = false
            }

        }
    },
}
